import GigyaService from "../services/gigya-service";
// import AdobeAnalyticsService from "../services/adobe-analytics-service";
import config from "../constants/config";

const { ENV_SUFIX } = config;

export const useOnInit = () => {
  const mfaApiKey = process.env[`REACT_APP_MFA_CDC_API_KEY${ENV_SUFIX}`];
  const isMfaFlow =
    window.location.pathname.toLowerCase().includes("mfa") ||
    document.referrer.toLowerCase().includes("mfa") ||
    sessionStorage.getItem("gig_apikey") === mfaApiKey;
  
  // Set up appropriate script based on flow type
  if (isMfaFlow) {
    if (mfaApiKey) {
      sessionStorage.setItem("gig_apikey", mfaApiKey);
    }
    GigyaService.setUpMfaCdcScript();
  } else {
    GigyaService.setUpCdcScript();
  }
  // Note: No script setup needed for cloud flow
  // const onInit = async () => {
  //   AdobeAnalyticsService.setUpAdobeAnalytics();
  // };

  // onInit();
};
